import { InjectionToken } from '@angular/core';

export interface PartnerNavbarConfig {
  localizeHomeLink: boolean;
  production: boolean;
  useOtpUserInfo?: boolean;
}

export const PARTNER_NAVBAR_CONFIG = new InjectionToken<PartnerNavbarConfig>('PARTNER_NAVBAR_CONFIG');
